// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { formatMessageWithLocale } from '../../../../utils/i18n';
import { getAllocationsAsAtDates } from '../../../../utils/disclaimers/comparison';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
}

const MaturityDisclaimer = ({ items, showItemNames, locale }: Props) => {
  const maturityItems = items.filter(i => !!i.allocations && !!i.allocations.maturity && i.allocations.maturity.length > 0);

  return (
    <DatesDisclaimer
      globalPrefix={formatMessageWithLocale('Disclaimers.MaturityBreakdown', locale)}
      itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
      itemDates={getAllocationsAsAtDates(maturityItems, locale)}
      showItemNames={showItemNames}
      locale={locale}
    />
  );
};

export default MaturityDisclaimer;
